import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-daochu",
  "use": "icon-daochu-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-daochu\"><path d=\"M448 281.6L326.4 403.2c-25.6 25.6-64 25.6-89.6 0-25.6-25.6-25.6-64 0-89.6l230.4-230.4c25.6-25.6 64-25.6 89.6 0 25.6 25.6 25.6 64 0 89.6L448 281.6V166.4c0-12.8-6.4-19.2-12.8-32-6.4-6.4-6.4-19.2 0-25.6l32-32c25.6-25.6 64-25.6 89.6 0l230.4 230.4c25.6 25.6 25.6 64 0 89.6-25.6 25.6-64 25.6-89.6 0L576 281.6v473.6c0 38.4-25.6 64-64 64s-64-25.6-64-64V281.6z m448 614.4V448c0-38.4 25.6-64 64-64s64 25.6 64 64v512c0 38.4-25.6 64-64 64H64c-38.4 0-64-25.6-64-64V448c0-38.4 25.6-64 64-64s64 25.6 64 64v448h768z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/daochu.svg
// module id = 5k29
// module chunks = 16